export default "__VITE_ASSET__rPlwY4au__"